import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import TextInput from '../../../../../inputs/TextInput'
import CheckBoxInputControlled from '../../../../../inputs/CheckboxInput/controlled'
import { selectCompanyData } from '../../../../../../../redux/selector/system'
import { CustomerModalFormAddressWrapper, CustomerModalFormLine, CustomerModalFormNameContainer, CustomerModalFormWrapper } from '../../../../../form/CustomerModalForm/index.styled'
import { filterName, filterPhone, formatAddressInInput } from '../../../../../form/CustomerModalForm/helper'
import { emailPattern } from '../../../../../../../helper/email'
import AddressFields from '../../../../../form/AddressFields'
import { selectIsInvoiceCorrection } from '../../../../../../../redux/selector/invoice'

const MainBillingAddressForm = ({ zIndex, onSubmit, handleSubmit, register, errors, setValue, watch, setFocus, clearErrors }) => {
	const { t } = useTranslation()
	const [isFirma, setIsFirma] = useState(true)
	const selectedInvoice = useSelector(store => store.invoice.selectedInvoice)
	const isInvoiceChangeEmail = useSelector(store => store.invoice.isInvoiceChangeEmail)
	const isInvoiceCorrection = useSelector(selectIsInvoiceCorrection)
	const companyCountryCode = useSelector(selectCompanyData('countryCode'))

	useEffect(() => {
		if (selectedInvoice && !selectedInvoice.customer?.billingAddress?.companyName) {
			setIsFirma(false)
		} else {
			setIsFirma(true)
		}
	}, [selectedInvoice.customer?.billingAddress?.companyName]) // eslint-disable-line react-hooks/exhaustive-deps

	const toggleFirmaShow = useCallback(() => {
		if (isFirma) setValue('companyName', null)
		setIsFirma(!isFirma)
	}, [isFirma, setValue])

	const handlePhoneChange = useCallback((e) => {
		e.target.value = filterPhone(e.target.value)
		setValue('phoneNumber', e.target.value)
	}, [setValue])

	const handleNameChange = useCallback((e) => {
		e.target.value = filterName(e.target.value)
		setValue('name', e.target.value)
	}, [setValue])

	return (
		<CustomerModalFormWrapper id="invoice-billing-address-form"
															data-testid="invoice-billing-address-form"
															onSubmit={handleSubmit(onSubmit)}>
			<CustomerModalFormLine>
				<TextInput testId="customer-phone-number"
									 name="phoneNumber"
									 tabIndex="901"
									 label={t('AddOrder.Client.form.Telefonnumer') + '*'}
									 errors={errors}
									 register={register}
									 options={{
										 required: t('app.validation.required'),
										 pattern: {
											 value: /^[0-9]{3,15}$/i,
											 message: t('app.validation.minNumber3')
										 }
									 }}
									 onChange={handlePhoneChange}
									 watch={watch('phoneNumber')}
									 color="gray"
									 inputMode="tel" />
				<TextInput testId="customer-number"
									 name="customerNumber"
									 tabIndex="902"
									 disabled={true}
									 label={t('AddOrder.Client.form.customerNumber')}
									 errors={errors}
									 register={register}
									 options={{
										 pattern: {
											 value: /^[0-9]{1,150}$/i,
											 message: t('app.validation.number')
										 }
									 }}
									 watch={watch('customerNumber')}
									 color="gray"
									 inputMode="tel" />
			</CustomerModalFormLine>
			<CustomerModalFormNameContainer className={isFirma ? 'columns' : ''}>
				<TextInput testId="customer-name"
									 name="name"
									 tabIndex="903"
									 label={t('AddOrder.Client.form.Name') + (!isFirma ? '*' : '')}
									 errors={errors}
									 register={register}
									 options={{
										 required: !isFirma && t('app.validation.required')
									 }}
									 onChange={handleNameChange}
									 watch={watch}
									 color="gray">
					<CheckBoxInputControlled id="firma-id" testId="firma-id" label={t('AddOrder.Client.form.Company')} className="firma-id"
																	 checked={isFirma} onChange={toggleFirmaShow} />
				</TextInput>
			</CustomerModalFormNameContainer>
			{isFirma &&
				<TextInput testId="customer-company"
									 name="companyName"
									 tabIndex="904"
									 errors={errors}
									 label={t('AddOrder.Client.form.Company') + (isFirma ? '*' : '')}
									 register={register}
									 options={{
										 required: isFirma && t('app.validation.required')
									 }}
									 color="gray"
									 watch={watch} />}
			<CustomerModalFormAddressWrapper>
				<AddressFields dataName="customerAddress"
											 firstTabIndex="905"
											 secondTabIndex="906"
											 thirdTbaIndex="907"
											 fourthTabIndex="908"
											 errors={errors}
											 watch={watch}
											 setValue={setValue}
											 setFocus={setFocus}
											 formatAddress={formatAddressInInput}
											 countryDataRequired={false}
											 geoDataRequired={false}
											 autocompleteRequest={true}
											 register={register}
											 countryCode={companyCountryCode}
											 returnZIndex={zIndex}
											 cols="cols-2"
											 color="gray"
											 clearErrors={clearErrors} />
			</CustomerModalFormAddressWrapper>
			{(isInvoiceChangeEmail || isInvoiceCorrection) && <TextInput testId="billing-address-email"
																					name="email"
																					label={t('AddOrder.Client.form.email') + '*'}
																					errors={errors}
																					register={register}
																					options={{
																						required: t('app.validation.required'),
																						pattern: {
																							value: emailPattern,
																							message: t('app.validation.invalid_email')
																						}
																					}}
																					watch={watch('email')}
																					color="gray" />}
		</CustomerModalFormWrapper>
	)
}

MainBillingAddressForm.displayName = 'MainBillingAddressForm'
export default MainBillingAddressForm
